import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

/**
 * Global Pinia instance to be shared among the apps and libs;
 */
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export { pinia };
